// extracted by mini-css-extract-plugin
export default {"Safety":"Safety_Safety__5m2fI","Safety__container":"Safety_Safety__container__SCHAp"};